var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileDarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9V7.5H12V9H6ZM6 6V4.5H12V6H6ZM4.5 10.5H10.125C10.4875 10.5 10.825 10.5782 11.1375 10.7347C11.45 10.8912 11.7125 11.113 11.925 11.4L13.5 13.4625V3H4.5V10.5ZM4.5 15H12.7875L10.7437 12.3187C10.6687 12.2187 10.5783 12.1408 10.4723 12.0848C10.3663 12.0288 10.2505 12.0005 10.125 12H4.5V15ZM13.5 16.5H4.5C4.0875 16.5 3.7345 16.3533 3.441 16.0598C3.1475 15.7663 3.0005 15.413 3 15V3C3 2.5875 3.147 2.2345 3.441 1.941C3.735 1.6475 4.088 1.5005 4.5 1.5H13.5C13.9125 1.5 14.2658 1.647 14.5598 1.941C14.8538 2.235 15.0005 2.588 15 3V15C15 15.4125 14.8533 15.7658 14.5598 16.0598C14.2663 16.3538 13.913 16.5005 13.5 16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDarkIcon);
export default __webpack_public_path__ + "static/media/profile-dark-icon.94f2e4778617e58be5b675b9af46290f.svg";
export { ForwardRef as ReactComponent };